module.exports = __webpack_public_path__ + "static/media/unlock.7ff22f2c.svg";